import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Table, Spin, Select, message, TimePicker, Form } from "antd";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getSelectedDepartmentId,
  getStatusListFromID,
  getAllDepartmentList,
  getClientid,
  getMenuList,
  getLocations,
  getUserList, getUserInfo,
} from "redux/selectors";
import COLORS from "common/Colors";
import { CALL_API } from "common/API";
import { CSVLink } from "react-csv";
import { reduce, concat, uniqBy } from "lodash";
import moment from "moment";
import { STATUS_CODE } from "common/Constants";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { setUserList } from "redux/actions";
import { bindActionCreators } from "redux";
// import { countryList } from "common/Constants";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledSelect = styled(Select)`
  width: 200px;
  margin: 0px;
`;

function Shift({
  userRoleId,
  selectedDepartmentId,
  ClientId,
  menuList,
  updateUserList,
  locationList, userInfo,
  userList
}) {
  const [shiftList, setShiftList] = useState([]);
  const [displayshiftLoader, setDisplayshiftLoader] = useState(false);
  const [shiftCSVlist, setShiftCSVlist] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [shiftFilterList, setShiftFilterList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [countryFilterList, setCountryFilterList] = useState([]);
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const csvLinkEl = useRef();
  const containerRef = useRef(null);
  const menuName = "countrynode";
  const [form] = Form.useForm();

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];

  useEffect(() => {
    if (userRoleId !== 5) setSelectedDepartment(selectedDepartmentId);
  }, [selectedDepartmentId]);

  const STAFF_LIST = uniqBy(
    shiftList.map((val) => {
      return { user_id: val?.userid, name: val?.fullname };
    }),
    "user_id"
  );

  useEffect(() => {
    var result;

    if (selectedStaff === "") {
      result = shiftList;
    } else {
      result = shiftList?.filter((data) => data?.userid === selectedStaff);
    }

    // setShiftFilterList(result);
  }, [selectedDepartment, shiftList, selectedStaff, selectedCountries]);
  const countryList = shiftList
    // .filter(user => LeaveList.some(attendance => attendance.userid === user.userid))
    .map(user => user.nationality);
  const uniqueCountryName = uniqBy(
    countryList?.map((item) => {
      return {
        label: item,
        value: item,
      };
    }),
    "value"
  );

  const uniqueEmployeeName = uniqBy(
    STAFF_LIST?.map((item) => {
      return {
        label: item.name,
        value: item.user_id,
      };
    }),
    "value"
  );

  const CSVHeaders = [
    { label: "Employee ID", key: "employeeid" },
    { label: "Name", key: "username" },
    { label: "Shift Start Time", key: "shiftstarttime" },
    { label: "Shift End Time", key: "shiftendtime" },
    { label: "Timezone", key: "timezone" },
  ];

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "10%",
    },
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
    },
    {
      title: "Shift Start Time",
      dataIndex: "shiftstarttime",
      key: "shiftstarttime",
      width: "10%",
      render: (_, render) => {
        let date = render?.shiftstarttime;
        return (
          <div>
            <TimePicker
              disabled={
                Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "shift" && subItem?.permission.edit
                    )
                )
                  ? false
                  : true
              }
              defaultValue={moment(date, "HH:mm")}
              format={"HH:mm"}
              onChange={(val) => {
                onUpdate(render?.userid, val, render?.shiftendtime);
              }}
              clearIcon={null}
              getPopupContainer={() => containerRef.current}
            />
          </div>
        );
      },
    },
    {
      title: "Shift End Time",
      dataIndex: "shiftendtime",
      key: "shiftendtime",
      width: "10%",
      render: (_, render) => {
        let date = render?.shiftendtime;
        return (
          <div>
            <TimePicker
              disabled={
                Menulist?.find(
                  (item) =>
                    item?.key === "manage" &&
                    item?.subMenu.find(
                      (subItem) =>
                        subItem?.key === "shift" && subItem?.permission.edit
                    )
                )
                  ? false
                  : true
              }
              defaultValue={moment(date, "HH:mm")}
              format={"HH:mm"}
              onChange={(val) => {
                onUpdate(render?.userid, render?.shiftstarttime, val);
              }}
              clearIcon={null}
              getPopupContainer={() => containerRef.current}
            />
          </div>
        );
      },
    },
    {
      title: "Timezone",
      dataIndex: "baselocationid",
      key: "baselocationid",
      width: "10%",
      render: (baselocationid) => {
        const timezone = locationList.filter(
          (item) => item.location_id === baselocationid
        );
        return timezone[0]?.usertimezone;
      },
    },
  ];

  useEffect(() => {
    getShiftList();
  }, []);

  const getShiftList = async () => {
    try {
      setDisplayshiftLoader(true);
      const response = await CALL_API(`user-shift/${ClientId}`, "get", {});
      console.log("Response-->", response); // Log the response
      console.log("NodeCheck-->", response.map(item => item.nationality)); // Check nationality node
      setShiftList(response);
      setShiftFilterList(response); // Initialize shiftFilterList with full shiftList
      setCountryFilterList(response); // Set country list from the response
      setDisplayshiftLoader(false);
    } catch (error) {
      console.log("[getShiftList] Error-->", error);
    }
  };

  const fetchMasterData = async (fetch_master_data) => {
    const { code, userList } = await CALL_API(
      `master-data/${ClientId}`,
      "post",
      {
        fetch_master_data,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      updateUserList(userList);
    }
  };
  const getFilterData = (country, employee) => {
    console.log("country--->", country);
    console.log("employee--->", employee);
    console.log("Shift List Nationality--->", shiftList.map(item => item.nationality));

    // Return full shiftList if both country and employee are empty
    if (country.length === 0 && employee.length === 0) {
      console.log("Returning full shift list as both filters are empty.");
      return shiftList ?? [];
    }

    const filterData = (shiftList ?? [])
      .filter((item) =>
        country.length > 0 ? country.some((c) => item.nationality?.trim().toLowerCase() === c.trim().toLowerCase()) : true
      )
      .filter((item) =>
        employee.length > 0 ? employee.some((e) => e.trim().toLowerCase() === item?.userid?.trim().toLowerCase()) : true
      );

    console.log("country filter applied--->", country);
    console.log("filterData--->", filterData);
    return filterData;
  };


  useEffect(() => {
    console.log("selectedCountries:", selectedCountries);
    setShiftFilterList(getFilterData(selectedCountries, selectedStaff))
  }, [selectedCountries, selectedStaff])

  const handleCountryFilterChange = () => {
    const values = form.getFieldsValue();
    setSelectedCountries(values.country || []);  // Directly set selected countries
  };


  const handleEmployeeFilterChange = () => {
    const values = form.getFieldsValue();
    setSelectedStaff(values.employee || []);
  };

  const onUpdate = async (Id, start_time, end_time) => {
    let shiftStartTime = moment(start_time, "HH:mm").format("HH:mm");
    let shiftEndTime = moment(end_time, "HH:mm").format("HH:mm");
    if (shiftStartTime || shiftEndTime) {
      setDisplayshiftLoader(true);
      const { code } = await CALL_API(`user-shift/${ClientId}/${Id}`, "patch", {
        shift_start_time: moment(shiftStartTime, "HH:mm").format("HH:mm"),
        shift_end_time: moment(shiftEndTime, "HH:mm").format("HH:mm"),
      });
      if (code === STATUS_CODE.SUCCESS) {
        setDisplayshiftLoader(false);
        message.success(`Successfully Updated`);
        getShiftList();
        fetchMasterData();
      } else {
        message.error(`Something went wrong. Please try again.`);
      }
    }
  };

  const prepareCSV = async () => {
    if (shiftFilterList?.length > 0) {
      setShiftCSVlist(
        reduce(
          shiftFilterList,

          function (result, list) {
            const timezone = locationList.filter(
              (item) => item.location_id === list?.baselocationid
            );
            result.push({
              "Employee ID": list?.employeeid,
              Name: list?.fullname,
              "Shift Start Time": moment(
                list?.shiftstarttime,
                "HH:mm:ss"
              ).format("HH:mm"),
              "Shift End Time": moment(list?.shiftendtime, "HH:mm:ss").format(
                "HH:mm"
              ),
              Timezone: timezone[0]?.usertimezone,
            });
            return result;
          },
          []
        )
      );
      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(`No data available to download.`);
    }
  };
  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };
  const headerstyle = { fontSize: "20px", fontWeight: "bold" };
  const emailList = userInfo.higherOfficialsList.map(official => official.email);
  const isChairman = userInfo.higherOfficialsList.some(
    (official) => official.role === "CHAIRMAN" && official.email === userInfo.userid
  );
  return (
    <>
      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        <Col xs={24} md={12} className="mt-6" style={headerstyle}>
          List of Shift
        </Col>
        <Col xs={24} md={12} className="align-right">
          <ButtonOutlined type="link" onClick={prepareCSV}>
            Export CSV file
          </ButtonOutlined>
          <CSVLink
            header={CSVHeaders}
            data={shiftCSVlist}
            filename={"shift-management.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>

      <div className="mt-2">
        <Form
          form={form}
          layout="vertical"
          onFinish={fetchMasterData}
          onValuesChange={() => {
            handleEmployeeFilterChange();
            handleCountryFilterChange();
          }}

          initialValues={{ employee: [], country: [] }}
        >
          <Row gutter={12} className="g-3 mb-2">

            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <DropdownCheckBox
                name="employee"
                label="Employee"
                options={uniqueEmployeeName}
                form={form}
                handleFormChange={handleEmployeeFilterChange}
              />
            </Col>
            {Menulist?.find(
              (item) =>
                item?.key === "countryfilter" &&
                item?.permission.view
            ) && isChairman && (
                <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                  <DropdownCheckBox
                    name="country"
                    label="Country"
                    options={uniqueCountryName}
                    form={form}
                    handleFormChange={handleCountryFilterChange}
                  />
                </Col>
              )}
          </Row>
        </Form>
      </div>

      <Spin spinning={displayshiftLoader}>
        <StyledTable
          ref={containerRef}
          dataSource={shiftFilterList}
          columns={columns}
          // note : first parameter is needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="userid"
          pagination={shiftFilterList?.length > 100 ? paginationOptions : false}
        />
      </Spin>
    </>
  );
}
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserList: setUserList,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  statusListFromID: getStatusListFromID(state, [4, 5, 6]),
  selectedDepartmentId: getSelectedDepartmentId(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps, mapDispatchToProps, null)(Shift);
